import { useFormContext } from 'react-hook-form';
import { useEnabledFeatures } from '../hooks/enabled-features/use-enabled-features';
import { EventPanelFormType } from '@mark43/cad-api';
import { FormSelect } from '../../forms/integrated-form-controls/form-select';
import { useEventFormCallForServiceOptions } from '../hooks/use-event-form-call-for-service-options';

export function EventFormAdditionalCallForServiceSelect({ mode }: { mode?: 'read-only' }) {
    const eventForm = useFormContext<EventPanelFormType>();
    const { additionalCallForService: additionalCallForServiceEnabled } = useEnabledFeatures();
    const callForServiceOptions = useEventFormCallForServiceOptions();

    if (!additionalCallForServiceEnabled) {
        return null;
    }

    return (
        <FormSelect
            control={eventForm.control}
            label="Additional CFS"
            name="additionalCallForServices"
            eventNotificationName="ADDITIONAL_CFS"
            options={callForServiceOptions}
            isMultiple
            asEditable
            truncateSelectedCount={2}
            mode={mode}
        />
    );
}
